import { Task, Tank, TankGroup } from "@/types/v2";
import { convertObjectKeysToCamel } from "@/utils/v2";

export const adaptTaskResponse = (task: object): Task => {
  const adaptedTask = convertObjectKeysToCamel(task);

  if (adaptedTask.details && adaptedTask.details.studyTanks) {
    adaptedTask.details.tanks = adaptedTask.details.studyTanks.map(
      (tank: Tank) => {
        const adaptedTank = convertObjectKeysToCamel(tank);

        return {
          ...adaptedTank,
          groups: adaptedTank.groups.map((group: TankGroup) =>
            convertObjectKeysToCamel(group)
          ),
        };
      }
    );

    delete adaptedTask.details.studyTanks;
  }

  return adaptedTask;
};
